export const EVENT_NAME = {
  ONSCROLL: 'onScroll',
  ONSCROLLEND: 'onScrollEnd',
  CELLAPPEARPREFIX: 'onCellAppear_', // 卡片出现前缀
};

/**
 * 渲染组件类型
 */
export const RENDER_TYPE = {
  /** 子包 */
  SUB: 'sub',
  /** 自定义组件 */
  CUSTOM: 'custom',
};

/**
* 组件吸顶
*/
export const STICKY_TYPE = {
  /** 不吸顶 （默认）*/
  0: 0,
  /** 吸顶 */
  1: 1,
};

// 主视图id
export const RootViewId = 'home-main-root';
// 地址栏
export const AddressBarTempID = 'mach_pro_sailor_c_home_page_address_bar_sub';
// 搜索栏
export const SearchBarTempID = 'mach_pro_sailor_c_home_page_header_searchbar_sub';
// 筛选
export const FilterBarTempID = 'mach_pro_sailor_c_home_page_header_filter_panel_sub';

export const FilterBarCommonTempID = 'mach_pro_sailor_c_common_filter_bar_sub';
// 金刚
export const KingKongTempID = 'mach_pro_sailor_c_home_page_header_kingkong_sub';
// 新版金刚
export const KingKongNewTempID = 'mach_pro_sailor_c_home_page_header_kingkong_new_sub';
// 商家卡片
export const ProductTempID = 'mach_pro_sailor_c_home_page_home_product_card_sub';
// 异形卡片
export const SpecialTempID = 'mach_pro_sailor_c_home_page_home_special_card_sub';
// 无数据兜底
export const PreheatTempID = 'mach_pro_sailor_c_area_preheat';

//v2 商卡id
export const HomePageCardV2ID = 'mach_pro_sailor_c_home_page_home_product_card_v2_sub';

// 无更多数据: 无下拉更多数据时前端自动拼接
export const NoMoredataTempID = 'mach_pro_sailor_c_no_more_data_mach_custom';
// 大促氛围
export const HomePageBgID = 'mach_pro_sailor_c_home_header_bg_sub';
// 顶通banner
export const PromotionBannerTempID = 'mach_pro_sailor_c_home_page_promotion_banner_sub';
// 黄金流程新商卡
export const GoldenProductCardTempID = 'mach_pro_sailor_c_home_page_feeds_card_golden';
// 通用商卡 + 下挂菜样式
export const GoldenProductGroceryCardTempID = 'mach_pro_sailor_c_home_page_feeds_grocery_card';
// 黄金流程店铺专区入口
export const GoldenShopBannerTempID = 'mach_pro_sailor_c_home_page_header_shop_banner_golden';

// 营销资源位
export const HomePageMKTResource = 'mach_pro_sailor_c_home_header_mkt_resource_sub';

// 首页骨架
export const SkeletonLoadingPageID = 'mach_pro_sailor_c_home_skeleton_defalut_page';

// 首页菜品专区入口
export const DishEntranceTempID = 'mach_pro_sailor_c_home_page_header_shop_dish_entrance';

// 新版头部view
export const TopViewTempID = 'mach_pro_sailor_c_home_page_header_top_view';

// 首页标题组件
export const HeaderTitleID = 'mach_pro_sailor_c_common_header_title_custom';

// 聚餐专区入口
export const GatheringTempID = 'mach_pro_sailor_c_home_page_header_gathering_card';

/// 默认氛围图样式
export const HomePageBgDefaultData = {
  component_id: HomePageBgID,
  component_properties: {
    render_type: 'custom'
  },
  layout_info: {},
  json_data: {}
};

/// 地址栏默认样式
export const AddressBarDefaultData = {
  component_id: AddressBarTempID,
  component_properties: {
    stick_type: STICKY_TYPE[1],
    render_type: RENDER_TYPE.SUB
  },
  layout_info: {},
  json_data: {}
};
/// 搜索框默认样式
export const SearchBarDefaultData = {
  component_id: SearchBarTempID,
  component_properties: {
    stick_type: STICKY_TYPE[1],
    render_type: RENDER_TYPE.SUB
  },
  layout_info: {},
  json_data: {
    styleInfo: {
    }
  }
};

export const SkeletonPageLoadingDefaultData = {
  component_id: SkeletonLoadingPageID,
  component_properties: {
    render_type: RENDER_TYPE.CUSTOM
  },
  layout_info: {},
  json_data: {
  }
};

/// 无数据兜底样式
export const PreheatItemDefaultData = {
  component_id: PreheatTempID,
  component_properties: {
    render_type: RENDER_TYPE.CUSTOM
  },
  layout_info: {},
  json_data: {
    sceneCode: 0,
    message: ''
  }
};

export enum HOME_PAGE_ERROR_CODE {
  PRE_PAGE_LOGIN_CODE = 201003221, // 预热页面-已登录
  PRE_PAGE_NO_LOGIN_COE = 201003222, // 预热页面-未登录
  LOGIN_CODE = 201003216, // 未开城-已登录
  NO_LOGIN_CODE = 201003217, // 未开城-未登录
  NO_SUPPLY_AREA = 201003206, // 无供给
  NO_DATA = 201003207, // 无数据
  NO_SERVICE = 201003213, // 不在服务范围：pageInfo接口在用
  LOADING = 20230505, // 加载中
  OTHER_EMPTY_PAGE = 201003225, // 其他页面为空
  NUCLEAR_BUTTON = 201003555, // 核按钮
}

export const HomePageEmptyImgMapping = {
  201003206: 'assets://common/empty.png', // 首页无供给
  201003207: 'assets://common/empty.png', // 首页无数据
  201003225: 'assets://common/empty.png', // 非首页无数据
  20230505: '',
};

export const HomePgaeLodaingItemData = {
  component_id: PreheatTempID,
  component_properties: {
    render_type: RENDER_TYPE.CUSTOM
  },
  layout_info: {},
  json_data: {
    sceneCode: HOME_PAGE_ERROR_CODE.LOADING, // 加载中
    message: ''
  }
};

const Login = Mach.requireModule('Login');

// 首次请求接口时，加载中动画数据
export const HomePgaeFirstLoadingPageInfoData = {
  module_header: {
    component_list: Login?.isLogin?.() ? [HomePageBgDefaultData, AddressBarDefaultData, SearchBarDefaultData, SkeletonPageLoadingDefaultData] : [HomePageBgDefaultData, AddressBarDefaultData, SkeletonPageLoadingDefaultData]
  }
};

export const HomePgaeFirstLoadingShopListData = {
  module_body: {
    component_list: [HomePgaeLodaingItemData]
  }
};

/// 子包下载失败需要降级的白名单：目前只有商家卡片
export const DegradationSubPackagesList = [
  AddressBarTempID,
  SearchBarTempID,
];

export const isPrePage = (code: number) => code === HOME_PAGE_ERROR_CODE.PRE_PAGE_LOGIN_CODE || code === HOME_PAGE_ERROR_CODE.PRE_PAGE_NO_LOGIN_COE || code === HOME_PAGE_ERROR_CODE.NUCLEAR_BUTTON;

export const isNoService = (code: number) => code === HOME_PAGE_ERROR_CODE.LOGIN_CODE || code === HOME_PAGE_ERROR_CODE.NO_LOGIN_CODE;

export const TAB_INDEX = {
  HOMEPAGE: 0,
  // 购物车 1 该Tab暂未展示
  ORDER: 2,
  MINE: 3
};

export const TAB_ICON_TYPE = {
  DEFAULT: 0,
  TO_TOP: 1
};

export const AddressBarDialogIntervalChannelKey = 'com.keeta.home';
export const AddressBarDialogIntervalCacheKey = 'com.keeta.home.address.bar.dialog.interval.cache';

export enum REFRESH_TYPE {
  /** 上拉加载 */
  PULL_UP = -1,
  /** 下拉刷新 */
  PULL_DOWN = 0,
  /** 点击筛选栏 */
  CLICK_FILTERBAR = 1,
  /** 点击Tab栏 */
  CLICK_SCENETAB = 2,
  /** 点击筛选栏刷新筛排缓存 - 当前仅点击自取场景使用 */
  CLICK_FILTERBAR_REFRESH_TAG = 3,
}

export const HeaderViewBgCornerHeight = 12;
